import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';
import { primitive } from 'styles/constants/primitives';

export const Group = styled.div`
  background-color: ${Styles.color.cardBackground};
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
`;

export const HeaderWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: ${p => p.theme.token('padding-list-item-group-header')};
`;

export const HeaderText = styled.h3<{ $isNested?: boolean }>`
  font: ${p => (p.$isNested ? brandFont.headerFour : brandFont.headerThree)};
  margin: 0;
`;

export const SubHeaderText = styled.p`
  padding: ${primitive.$spacing1} ${primitive.$spacing4};
  font: ${brandFont.copyTwo};
  margin: -${primitive.$spacing2} 0 0 0;
`;

export const Footer = styled.div`
  border-bottom: 1px solid #dcdcdc;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  min-height: 2.5rem;
  padding: ${primitive.$spacing1} ${primitive.$spacing4};
`;
